import type {
  ApprovalRegion,
  ApprovalStatusFilter,
  ApprovalRowStatus,
} from "./types.ts";

export const STATUS_FILTER_OPTIONS: ReadonlyArray<{
  value: ApprovalStatusFilter;
  label: string;
}> = [
  { value: "PENDING", label: "Pending" },
  { value: "APPROVED", label: "Approved" },
  { value: "REJECTED", label: "Rejected" },
  { value: "ALL", label: "All" },
];

export const REGION_OPTIONS: ReadonlyArray<{
  value: ApprovalRegion;
  label: string;
}> = [
  { value: "INDIA", label: "India" },
  { value: "US", label: "US" },
  { value: "UK", label: "UK" },
  { value: "SQE", label: "SQE Labs" },
  { value: "GLOBAL", label: "Global" },
];

export const ROW_STATUS_VARIANT: Record<
  ApprovalRowStatus,
  "success" | "warning" | "danger" | "neutral"
> = {
  APPROVED: "success",
  PENDING: "warning",
  REJECTED: "danger",
  SKIPPED: "neutral",
};

export const ROW_STATUS_LABEL: Record<ApprovalRowStatus, string> = {
  APPROVED: "Approved",
  PENDING: "Pending",
  REJECTED: "Rejected",
  SKIPPED: "Skipped",
};

export const DEFAULT_STATUS_FILTER: ApprovalStatusFilter = "PENDING";
